/**
 * 대표 공종 — 백엔드 `VendorCodes.TRADES` 와 같은 여덟 값.
 *
 * `vendor/` 는 `front/` 를 import 하지 않으므로(eslint) 한 벌 더 적는다. 서버 CHECK 가 최종 심판이라
 * 두 벌이 어긋나면 400 으로 드러난다(DOC-96 §5).
 */
export const TRADES = ['건축', '구조', '기계', '전기', '통신', '토목', '조경', '기타'] as const;

export type Trade = (typeof TRADES)[number];
